import Vue from 'vue';

const DayPlugin = {
  install(Vue) {
    Vue.mixin({
      computed: {
        $date() {
          return date => {
            return date ? this.$dayjs(new Date(date)).format('YYYY-MM-DD') : '';
          };
        },
        $time() {
          return (time, options = { format: 'YY년 MM개월 DD일 HH시간 mm분 ss초' }) => {
            return time !== undefined ? this.$dayjs.duration(time * 1000).format(options.format) : time;
          };
        },
        $datetime() {
          return date => {
            return date ? this.$dayjs(new Date(date)).format('YYYY-MM-DD HH:mm:ss') : '';
          };
        },
        $dateHourMinutes(){
          return date => {
            return date ? this.$dayjs(new Date(date)).format('YYYY-MM-DD HH:mm') : '';
          };
        },
        $thisWeek() {
          return (options = { format: 'YYYY-MM-DD', firstSuffix: '', lastSuffix: '', includeToday: true, weekType: '' }) => {
            options.format = options.format || this.$t('dashboard.weekFormat');
            options.firstSuffix = options.firstSuffix || '';
            options.lastSuffix = options.lastSuffix || options.firstSuffix || '';

            const daysToSubtract = options.weekType === 'overview' ?
            (options.includeToday ? 6 : 7) :
            (options.includeToday ? 7 : 8);

            const weekAgo = this.$dayjs()
              .add(-daysToSubtract, 'day')
              .format(options.format);
            const yesterday = this.$dayjs()
              .add(options.includeToday ? 0 : -1, 'day')
              .format(options.format);

            return `${weekAgo} ${options.firstSuffix} ~ ${yesterday} ${options.lastSuffix}`;
          };
        },
        $thisMonth() {
          return (options = { format: 'YYYY-MM-DD', firstSuffix: '', lastSuffix: '', includeToday: true }) => {
            options.format = options.format || this.$t('dashboard.weekFormat');
            options.firstSuffix = options.firstSuffix || '';
            options.lastSuffix = options.lastSuffix || options.firstSuffix || '';

            const monthAgo = this.$dayjs()
              .add(options.includeToday ? 0 : -1, 'day')
              .add(-1, 'month')
              .format(options.format);
            const yesterday = this.$dayjs()
              .add(options.includeToday ? 0 : -1, 'day')
              .format(options.format);
            return `${monthAgo} ${options.firstSuffix} ~ ${yesterday} ${options.lastSuffix}`;
          };
        },
        $duration() {
          return (seconds, format = this.$t('dashboard.hourMinute')) => {
            return this.$dayjs.duration(seconds || 0, 'seconds').format(format);
          };
        },
        $HoursAndMinutes() {
          const THIS = this;
          return (time, timeType = 'seconds') => {
            const $day = this.$dayjs.duration({ [timeType]: time });
            const hours = Math.floor($day.asHours());
            const minutes = Math.floor((($day.asMinutes() / 60) % 1) * 60);

            return THIS.$t('common.date.time', {hour: hours, minute: minutes});
          };
        },
      },
    });
  },
};

Vue.use(DayPlugin);
